<template>
  <ComingSoonFeatureVote
    
    :title="$t('broker.app.navigation.leagues')"
    :description="$t('broker.leagues.leaguesDescription')"
    :image-src="imageSrc"
    feature-name="COMING_FEATURE_LEAGUES"
  />
</template>

<script>
import ComingSoonFeatureVote from "../components/ComingSoonFeatureVote.vue";

export default {
  name: "RankingView",
  components: {
    ComingSoonFeatureVote,
  },
  data() {
    return {
      imageSrc: require("../assets/Image-Leagues.png"),
    };
  },
};
</script>
